"use strict";
/*
 * Created on 29. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var UserInfo_1 = require("../../user/model/UserInfo");

var ReleaseAction_1 = require("./ReleaseAction");
/**
 * Feasibility of release action.
 * @author Radek Beran
 */


var ReleaseActionFeasibility =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ReleaseActionFeasibility, _DomainObject_1$Domai);

  /**
   * @param action
   * @param allowed
   * @param lockedBy
   */
  function ReleaseActionFeasibility(action, allowed, lockedBy) {
    var _this;

    _classCallCheck(this, ReleaseActionFeasibility);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseActionFeasibility).call(this));
    _this.action = action;
    _this.allowed = allowed;
    _this.lockedBy = lockedBy;
    return _this;
  }

  return ReleaseActionFeasibility;
}(DomainObject_1.DomainObject);

exports.ReleaseActionFeasibility = ReleaseActionFeasibility; // tslint:disable-next-line:member-ordering

ReleaseActionFeasibility.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ReleaseActionFeasibility.name);
  return {
    action: builder.senum('action', ReleaseAction_1.ReleaseAction, CodebookLookupSequence_1.CodebookLookupSequence.ReleaseActions),
    allowed: builder.bool('allowed'),
    lockedBy: builder.opt(builder.obj('lockedBy', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    }))
  };
}();